export default "__VITE_ASSET__BPTS3chQ__"